var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helpdesk-ticket-slot"},[(_vm.ticketId)?_c('ticket-details',{key:_vm.ticketId,attrs:{"id":_vm.ticketId,"embedded":""}}):_c('div',{staticClass:"text-muted p-2"},[_vm._v("No se encontró el ticket.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }